export default "__VITE_ASSET__cbff7e5b__"